import { render, staticRenderFns } from "./ObjectsRegistry.vue?vue&type=template&id=4c116523&scoped=true&"
import script from "./ObjectsRegistry.vue?vue&type=script&lang=js&"
export * from "./ObjectsRegistry.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsRegistry.vue?vue&type=style&index=0&id=4c116523&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c116523",
  null
  
)

export default component.exports